import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabClientDetails from '../../form-fields/tab-client-details/tab-client-details';
class EditViewClientTabClientDetails extends Component {
  render() {    
    return (
      <div>
        <FormFieldsTabClientDetails 
          {...this.props}
          locked={this.props.locked}
          // referralsourcesList={this.props.referralsourcesList.referralsources}
          referralsourcesList={this.props.referralsourcesList}
        />
      </div>
    );
  }
}
EditViewClientTabClientDetails.propTypes = {
  /*** fix make required */
  locked: PropTypes.bool,
  /*** fix make required */
  referralsourcesList: PropTypes.array,
}
EditViewClientTabClientDetails = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabClientDetails);
export default EditViewClientTabClientDetails;